import {
  GAS_FAILURE,
  GAS_PENDING,
  GAS_SUCCESS,
  DA_SUCCESS,
  UA_SUCCESS,
  CA_SUCCESS,
  GNAS_SUCCESS,
  GNAS_PENDING,
  GACS_PENDING,
  GACS_SUCCESS,
} from './constants'

const initialState = {
  audits: null,
  error: null,
  isLoading: false,
  isCountLoaded: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GAS_PENDING:
      return {
        ...state,
        isLoading: true,
        isCountLoaded: true,
        error: null,
        audits: [],
      }
    case GAS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCountLoaded: false,
        error: null,
        ...action.payload,
      }
    case GNAS_PENDING:
      return {
        ...state,
        isLoading: false,
        error: null,
        audits: [...state.audits, {id: 'loading', name: ''}],
      }
    case GNAS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isCountLoaded: false,
        audits: [...state.audits, ...action.payload.audits],
      }
    case DA_SUCCESS:
      const indexOfDeleteAudit = state.audits.findIndex(a => {
        return a.id === action.payload
      })
      state.audits.splice(indexOfDeleteAudit, 1)
      return {
        ...state,
      }
    case UA_SUCCESS:
      const indexOfUpdateAudit = state.audits.findIndex(a => {
        return a.id === action.payload.id
      })
      state.audits[indexOfUpdateAudit] = action.payload
      return {
        ...state,
      }
    case CA_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case GAS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }

    case GACS_PENDING:
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    case GACS_SUCCESS:
      const UpdatedAudits = state.audits.map(a => {
        action.payload.total_and_scanned_items_count.map(c => {
          if (a.id === c.id) {
            a.scanned_items_count = c.scanned_items_count
            a.total_items_count = c.total_items_count
          }
          return true
        })
        return a
      })
      return {
        ...state,
        isCountLoaded: true,
        error: null,
        audits: [...UpdatedAudits],
      }
    default:
      return state
  }
}

export default reducer
